import React from "react";

const InvoiceCard = ({ stats }) => {
  return (
    <div className="row g-2 h-100 ">

      {stats.map((item, index) => {
        const Icon = item.icon;

        return (
          <div className="col-md-6 d-flex" key={index}>

            <div
              className="card border-0 w-100"
              style={{
                borderRadius: "12px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                padding: "16px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center h-100">

                {/* LEFT SIDE */}
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "3px",
                      height: "40px",
                      background: "#ff3b3b",
                      borderRadius: "2px",
                      marginRight: "12px",
                    }}
                  />

                  <div>
                    <div style={{ fontSize: "13px", color: "#777" }}>
                      {item.title}
                    </div>
                    <div style={{ fontWeight: "600", fontSize: "18px" }}>
                      {item.value}
                    </div>
                  </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="text-end">
                  <div
                    style={{
                      background: "#22c55e",
                      color: "#fff",
                      fontSize: "11px",
                      padding: "3px 10px",
                      borderRadius: "20px",
                      marginBottom: "8px",
                      display: "inline-block",
                    }}
                  >
                    +10%
                  </div>

                  <div
                    style={{
                      background: "#ffedd5",
                      padding: "8px",
                      borderRadius: "8px",
                      display: "inline-block",
                    }}
                  >
                    <Icon size={16} color="#f97316" />
                  </div>
                </div>

              </div>
            </div>

          </div>
        );
      })}

    </div>
  );
};

export default InvoiceCard;